const module = { name: 'shared/global/covidAnnouncementModal', exports: {} }; const exports = module.exports;



import { global_consts as global_consts_CookieNames } from 'require-core';

const { CookieNames } = global_consts_CookieNames;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_cookie as Fandango_cookie_get_getCookie_set_setCookie } from 'require-core';

const { get: getCookie, set: setCookie } = Fandango_cookie_get_getCookie_set_setCookie;


import { Fandango_queryUtil as Fandango_queryUtil_getParam } from 'require-core';

const { getParam } = Fandango_queryUtil_getParam;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_Dialog as fdDialog } from 'require-global';



import { Fandango_overlay as fdOverlay } from 'base-libraries';



import { Fandango_sanitizer as sanitizer } from 'require-core';



import { Fandango_eventQueue as eventQueue } from 'require-global';



const { EventNames } = eventQueue


const Selectors = {
    CLOSE_BTN: '#covid-modal-close-btn, .js-covid-modal-close-btn',
    MODAL: '#covid-modal',
    SEE_NEAR_THEATERS: '#covid-modal-cta-link'
}


const QueryParams = {
    SHOW_NOW: 'ff:covid-modal',
}


const Styles = {
    mobile: {
        OVERLAY: 'covid-modal-overlay',
        CLOSE_BTN: 'covid-overlay__close-btn'
    },
}


const RegExes = {
    COVID_MODAL: /cmodal=(.*)/
}


const COOKIE_TTL = 1000 * 60 * 60 * 24 * 365
function shouldShow(currentVersion, showNext) {
    const partnerCookie = getCookie(CookieNames.PARTNER_CAMP);
    const partnerConfig = typeof partnerCookie === 'string' && partnerCookie.match(RegExes.COVID_MODAL);
    const cookieDisabled = Array.isArray(partnerConfig) && partnerConfig[1];
    if (cookieDisabled === '0') {
        return false;
    }
    const queryEnabled = getParam(QueryParams.SHOW_NOW);
    if (queryEnabled) {
        return sanitizer.boolean(queryEnabled);
    }
    const cookie = getCookie(CookieNames.COVID_ANNOUNCEMENT_MODAL);
    let lastVersion = -1;
    let viewedOn = -1;
    if (cookie) {
        try {
            const j = JSON.parse(cookie);
            lastVersion = j.lastVersion || lastVersion;
            viewedOn = j.viewedOn || viewedOn;
        }
        catch (e) {
            debugLog.error('covidModal.parse', e);
        }
    }
    const age = Date.now() - viewedOn;
    const expired = age > showNext;
    const newerVersion = lastVersion < currentVersion;
    return expired || newerVersion;
}
function wasShown(version) {
    const payload = JSON.stringify({
        lastVersion: version || -1,
        viewedOn: Date.now(),
    });
    setCookie(CookieNames.COVID_ANNOUNCEMENT_MODAL, payload, {
        expires: COOKIE_TTL,
    });
}
function onSeeNearTheatersMobileClick() {
    track({
        event: EventTypes.GENERIC_CLICK,
        genericClickDetails: 'welcome back modal see cinemas near you'
    });
}
function onSeeNearTheatersDesktopClick() {
    window._satellite && window._satellite.track('welcome back modal see cinemas near you');
}
function showMobile(container) {
    function onCloseClick() {
        fdOverlay.close(overlay);
        eventQueue.emit(EventNames.COVID_OVERLAY, { closed: true });
        track({
            event: EventTypes.GENERIC_CLICK,
            genericClickDetails: 'welcome back modal got it clicks'
        });
    }
    const opts = {
        overlayStyle: Styles.mobile.OVERLAY,
        closeBtnParent: Selectors.MODAL,
        closeBtnStyle: Styles.mobile.CLOSE_BTN,
        microModalOpts: {
            onClose() {
                eventQueue.emit(EventNames.COVID_OVERLAY, { closed: true });
            }
        }
    };
    const overlay = fdOverlay.open(container, opts);
    container.classList.remove('hide');
    $(Selectors.SEE_NEAR_THEATERS).on('click', onSeeNearTheatersMobileClick);
    $(Selectors.CLOSE_BTN).on('click', onCloseClick);
    track({
        event: EventTypes.MODAL,
        pageType: 'modal',
        modalName: 'theaters | welcome back modal'
    });
}
function showDesktop() {
    function onCloseClick() {
        dialog.close();
        window._satellite && window._satellite.track('welcome back modal got it clicks');
    }
    const dialog = new fdDialog(Selectors.MODAL);
    dialog.open();
    $(Selectors.SEE_NEAR_THEATERS).on('click', onSeeNearTheatersDesktopClick);
    $(Selectors.CLOSE_BTN).on('click', onCloseClick);
    window._satellite && window._satellite.track('theaters | welcome back modal');
}
function init() {
    const container = document.querySelector(Selectors.MODAL);
    const platform = container && container.dataset.platform;
    if (!container || !platform) {
        return eventQueue.emit(EventNames.COVID_OVERLAY, { notShown: true });
    }
    const version = sanitizer.integer(container.dataset.version, -1);
    const showNext = sanitizer.integer(container.dataset.showNext, 0);
    if (!shouldShow(version, showNext)) {
        return eventQueue.emit(EventNames.COVID_OVERLAY, { notShown: true });
    }
    if (platform === 'mobile') {
        showMobile(container);
    }
    else {
        showDesktop();
    }
    wasShown(version);
    eventQueue.emit(EventNames.COVID_OVERLAY, { showing: true });
}
module.exports = {
    init,
};
export default module.exports;